export enum FoundYourTeamPageType {
  FOUND_YOUR_TEAM_PAGE,
  CONFIRMATION_PAGE,
}
